<script>
import { mapMutations } from "vuex";

export default {
    computed:{
        is_edvisor(){
            return this.$store.state.user.user.role.is_supervisor
        },
    },
    methods: {
        ...mapMutations({
            SetLimited:'regis_discepline/SET_LIMITED',
        }),

        async getMaxAndMin(){
            try{
                var route  = this.$route.query
                var params = {}

                if(this.is_edvisor){
                    params = {
                        study_year:route.study_year,
                        acad_period:route.acad_period,
                        student:route.student
                    }
                }else{
                    params = {
                        study_year:route.study_year,
                        acad_period:route.acad_period
                    }
                }

                await this.$http.get("/common/credit_student_profiles/",{params:params})
                    .then(res=>{
                        var limit = res.data

                        this.SetLimited({
                            min:limit.min_credit,
                            max:limit.max_credit,
                            current:limit.current_count,
                            onway:limit.onway
                        })
                    })
                    .catch(e=>{
                        console.error(e);
                    })

            }
            catch(e){
                console.error(e);
            }
        }
    },
}
</script>
